import React, { useState, useEffect } from "react";
import Select, { ActionMeta, SingleValue } from "react-select";

interface Option {
  label: string;
  value: number;
}

const paymentMethodOptions: Option[] = [
  { label: "Beca", value: 1 },
  { label: "Domiciliación bancaria", value: 2 },
  { label: "Efectivo", value: 3 },
  { label: "Financiación", value: 4 },
  { label: "Transferencia", value: 5 },
];

function CustomSelectWidget(props: any) {
  const { id, value, required, disabled, readonly, onChange } = props;
  const [selectedOption, setSelectedOption] = useState<Option | null>(null);

  useEffect(() => {
    const currentSelectedOption = paymentMethodOptions.find(
      (option) => option.value === value
    );
    setSelectedOption(currentSelectedOption || null);
  }, [value]);

  const handleOnChange = (
    newValue: SingleValue<Option>,
    actionMeta: ActionMeta<Option>
  ) => {
    const selectedOption = newValue as Option | null;
    setSelectedOption(selectedOption);
    const model = selectedOption?.value ?? null;
    onChange(model);
  };

  const selectStyles = {
    control: (provided: any) => ({
      ...provided,
      borderColor: "#E7F5F2",
      backgroundColor: "#E7F5F2",
      borderRadius: "0.25rem",
    }),
  };

  return (
    <Select
      id={id}
      options={paymentMethodOptions}
      value={selectedOption}
      required={required}
      isDisabled={disabled || readonly}
      onChange={handleOnChange}
      styles={selectStyles}
      placeholder="Todos los métodos"
      isClearable={true}
    />
  );
}

function PaymentMethodSelector(props: any) {
  const { id, options, value, required, disabled, readonly, onChange } = props;
  return (
    <CustomSelectWidget
      id={id}
      options={options?.enumOptions}
      value={value}
      required={required}
      disabled={disabled}
      readonly={readonly}
      onChange={onChange}
    />
  );
}

export default PaymentMethodSelector;
